import { ComponentProps } from 'react';
import TimePicker from 'antd/es/time-picker';
import clsx from 'clsx';
import dayjs, { Dayjs } from 'dayjs';

import { TIME_FORMAT } from 'constants/Dates';

import './OpTimePicker.scss';

interface OpTimePickerProps
  extends Omit<
    ComponentProps<typeof TimePicker>,
    'value' | 'onChange' | 'picker'
  > {
  testId?: string;
  gtm?: string;
  value?: Dayjs | string;
  onChange?: (value: string | null, timeString: string | string[]) => void;
}

export const OpTimePicker = ({
  className = '',
  testId = 'op-time-picker',
  gtm,
  value,
  format = TIME_FORMAT,
  onChange,
  ...timePickerProps
}: OpTimePickerProps) => {
  // We want to store a string in the form values rather than a dayjs object
  const handleChange = (
    changedValue: Dayjs | null,
    timeString: string | string[],
  ): void => {
    onChange?.(changedValue ? changedValue.toISOString() : null, timeString);
  };

  // We need to convert the now stored string to a dayjs object
  const pickerValue = typeof value === 'string' ? dayjs(value) : value;

  return (
    <TimePicker
      className={clsx('op-time-picker', className)}
      data-testid={testId}
      data-gtm={gtm}
      format={format}
      needConfirm={false}
      value={pickerValue}
      onChange={handleChange}
      {...timePickerProps}
    />
  );
};
